<template>
  <div class="grid scrollbar-style">
    
    <div class="row" v-if="showUpload">
      <div class="cell-sm-12 cell-md-8">
        <input type="file" data-role="file" data-prepend=".txt to Upload:" @change="processFile($event)">
      </div>
      <div class="cell-sm-12 cell-md-4">
        <button class="button primary" @click.prevent="onUploadFile" :disabled="!selectedFile && !uploading">
          <span>Upload</span>
      </button>
      </div>
    </div>
    <div class="row" >
      <div class="cell-full" v-if="selectable">
        Click on check button to select
      </div>
      <div class="cell-full" :class="{'activated':fi==selectedItem}" style="display:flex;align-items:center" v-for="(fi,idx) in list" :key="idx">
        <div style="flex:0 0 60px;padding:0px 5px">{{fi.id}}</div>
        <div style="flex:0 0 150px;padding:0px 5px">{{fi.datetime}}</div>
        <div style="flex:1 1 auto;text-align:right;padding:0px 5px">{{fi.signatures.join(',')}}</div>
        <div style="flex:0 0 120px;padding:0px 5px">
          <button class="button light">
            <span class="mif-cloud-download mif-2x"></span>
          </button>
          <button class="button light" @click="onSelect(fi)">
            <span class="mif-checkmark mif-2x"></span>
          </button>
        </div>
      </div>
    </div>
    <div class="row" v-if="showProcessor && selectedItem">
      <div class="cell-full">
        Select processor
      </div>
        <div class="cell-full" style="display:flex;align-items:center" v-for="(pr,idx) in processors" :key="idx">
        <div style="flex:0 0 60px;padding:0px 5px">{{pr.id}}</div>
        <div style="flex:1 1 auto;padding:0px 5px">{{pr.name}}</div>
        <div style="flex:0 0 60px;padding:0px 5px" @click="onRunDAG(pr)">
          <button class="button light">
            <span class="mif-play mif-2x"></span>
          </button>
        </div>
      </div>
    </div>
    <div data-role="progress" data-type="line" data-small="true" v-if="loading"></div>
  </div>
</template>

<script>
import axios from "axios";
import _ from "underscore";
import moment from "moment";

import settings from '../../../settings.js';
import globals from '../../../globals.js';

export default {
  props:{
    showUpload:undefined,
    showProcessor:undefined,
    selectable:undefined,
    folderToCheck:undefined,
    refreshInSeconds:undefined
  },
  data() {
    return {
      list: [],
      processors:[ ],
      loading:false,
      uploading:false,
      selectedFile:undefined,
      selectedItem:undefined
    };
  },
  mounted() {
    this.getData();
    this.$root.$on("refresh-news", () => {
      this.getData();
    });
    if (this.refreshInSeconds)
      setInterval(this.getData,this.refreshInSeconds*1000);
  },
  methods: {
    async onUploadFile(){
      this.uploading=true;
      let formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('folder',this.folderToCheck);
      formData.append('tokenValue',globals.getToken());
      let response=await axios.post(`${settings.serviceUrl}upload/file/`,formData,{headers: {'Content-Type': 'multipart/form-data'}});
      if (response.data.ok){
      }
      this.uploading=false;
    },
    async processFile(event){
      this.selectedFile = event.target.files[0];
    },
    onSelect(item){
      this.selectedItem=item;
    },
    isSelected(item){
      this.selectedItem==item;
    },
    async onRunDAG(){
      this.loading=true;
      let r = await axios.post(`${settings.serviceUrl}dags/run`,{dagId:pr.dagId,tokenValue:globals.getToken()});
      this.loading=false;
    },
    async getData() {
      this.loading=true;
      let r = await axios.post(`${settings.serviceUrl}check/folder`,{folder:this.folderToCheck,tokenValue:globals.getToken()});
      this.list = r.data.payload;
      this.list.forEach(fi=>{
        if (this.selectedItem && (fi.id==this.selectedItem.id))
          this.selectedItem=fi;
      })
      r = await axios.post(`${settings.serviceUrl}dags/list`,{tokenValue:globals.getToken()});
      this.processors=r.data.payload;
      this.loading=false;
    }
  }
};
</script>

<style lang="less" scoped>
.grid {
  height: 100%;
  overflow: auto;
  .row{
    margin-left:0px !important;
    margin-right:0px !important
  }
  .activated{
    background-color:aqua
  }
}
</style>